import { css } from 'lit';
import sharedStyles from '../../../shared/styles';

export default [
  sharedStyles,
  css`
    tenable-job-board-filter {
      width: 70% !important;
    }

    .mobile-version {
      display: none;
    }

    .desktop-version {
      display: block;
    }

    .desktop-version.job-board-filter-search {
      display: flex;
      overflow: auto;
    }

    .job-board-filter-search {
      margin-bottom: var(--tenable-job-board-filter-search-margin-bottom, 1.5rem);
    }

    @media(max-width: 768px) {
      .desktop-version {
        display: none;
      }

      .desktop-version.job-board-filter-search {
        display: none;
      }

      .mobile-version {
        display: block;
      }
    }
  `,
];
